import React from 'react';
import Project from './Project';
import { NavLink } from 'react-router-dom';
import { projects } from './data';

export default function Projects({ handleColorApp, CardContainer, HeaderContainer, Cards, Body, Text }) {

    return (
        <div className={CardContainer}>
            <h1 className={HeaderContainer}>{'<'}Projects{'>'}</h1>
            <div className={Cards}>
                {projects.map(proj => {
                    const isExternal = /^https?:\/\//i.test(proj.link);
                    const projectNode = (
                        <Project
                            title={proj.title}
                            image={proj.image}
                            description={proj.description}
                            handleColorApp={handleColorApp}
                            Body={Body}
                            Text={Text}
                        />
                    );

                    return isExternal ? (
                        <a
                            key={proj.title}
                            href={proj.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                        >
                            {projectNode}
                        </a>
                    ) : (
                        <NavLink key={proj.title} to={proj.link} style={{ textDecoration: 'none' }}>
                            {projectNode}
                        </NavLink>
                    );
                })}

            </div>
        </div>
    )
}